import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchVehiclesFilters } from "../slices/getVehiclesFilters";

export const useGetVehiclesFilters = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const filtersRaw = useSelector((state) => state.vehiclesFilters.filterList);
    const loaded = useSelector((state) => state.vehiclesFilters.loaded);

    useEffect(() => {
        if (!token || loaded) {
            return;
        }
        dispatch(fetchVehiclesFilters({ token }));
    }, [dispatch, token, loaded]);

    return { filters: filtersRaw?.data || {} };
};